import { render, staticRenderFns } from "./ReadyAnswerList.vue?vue&type=template&id=206a1b4a&"
import script from "./ReadyAnswerList.vue?vue&type=script&lang=js&"
export * from "./ReadyAnswerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports